import { Routes } from '@angular/router';
const success = () => import('./features/success/pay-now-success.component').then(m => m.PayNowSuccessComponent);
const failure = () => import('./features/failure/pay-now-failed.component').then(m => m.PayNowFailedComponent);
export const routes: Routes = [
  {path: '', pathMatch: 'full', loadComponent: () => import('./features/donation/pay-now-customize.component').then(m => m.PayNowCustomizeComponent)},
  {path: 'political', loadComponent: () => import('./features/political/pay-now-political.component').then(m => m.PayNowPoliticalComponent)},
  {path: 'pledge', loadComponent: () => import('./features/pledge/pay-now-pledge.component').then(m => m.PayNowPledgeComponent)},
  {path: 'paysuccess', loadComponent: success},
  {path: 'paysuccess/:organizationid', loadComponent: success},
  {path: 'payfailed', loadComponent: failure},
  {path: 'payfailed/:organizationid', loadComponent: failure},
  {path: '**', loadComponent: () => import('./shared/not-found.component').then(m => m.NotFoundComponent)},
];
